// config.js

import { ConfigInterface } from "./common/interfaces";

// Helper function to get the domain extension
const getDomainExtension = (): string | undefined => {
  if (!window.location.hostname.includes("kompare")) return undefined;
  const parts = window.location.hostname.split(".");
  return parts[parts.length - 1];
};

// Cloudflare Turnstile sitekeys (public by design). Production uses the kompare.hr widget
// shared with ao-checkout, kompare.work has its own real widget (each secret is
// TURNSTILE_SECRET_KEY on the matching health-api); everywhere else the always-pass
// test key, which renders a widget that solves itself.
const TURNSTILE_TEST_SITE_KEY = "1x00000000000000000000AA";
const TURNSTILE_PRODUCTION_SITE_KEY = "0x4AAAAAAEjAOHsUMjdHEUX1";
const TURNSTILE_WORK_SITE_KEY = "0x4AAAAAAEjtHXvGqJsw2keO";
const TURNSTILE_SITE_KEYS: Record<string, string> = {
  hr: TURNSTILE_PRODUCTION_SITE_KEY,
  work: TURNSTILE_WORK_SITE_KEY,
};

// Elastic APM RUM intake. Dev hosts report to the dev stack (ns `logging` on kompare-dev,
// Kibana at kibana.kompare.work) so test traffic never lands in production APM.
const APM_SERVER_URL_PRODUCTION = "https://apm-rum.kompare.hr/";
const APM_SERVER_URL_DEV = "https://apm-rum.kompare.work/";

const getEnvVars = (): ConfigInterface => {
  const domainExtension: string | undefined = getDomainExtension();

  if (!domainExtension) return {
    REACT_APP_IS_DEV: process.env.REACT_APP_IS_DEV ?? '',
    REACT_APP_URL: process.env.REACT_APP_URL ?? '',
    REACT_APP_KOMPARE_API_URL: process.env.REACT_APP_KOMPARE_API_URL ?? '',
    REACT_APP_API_URL: process.env.REACT_APP_API_URL ?? '',
    REACT_APP_DMS_URL: process.env.REACT_APP_DMS_URL ?? '',
    REACT_APP_KOMPARE_HOME: process.env.REACT_APP_KOMPARE_HOME ?? '',
    REACT_APP_WSPAY_URL: process.env.REACT_APP_WSPAY_URL ?? '',
    REACT_APP_ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT ?? '',
    REACT_APP_API_URL_ADDITIONAL: process.env.REACT_APP_API_URL_ADDITIONAL ?? '',
    REACT_APP_TARGET_ORIGIN: process.env.REACT_APP_TARGET_ORIGIN ?? '',
    REACT_APP_TURNSTILE_SITE_KEY: process.env.REACT_APP_TURNSTILE_SITE_KEY || TURNSTILE_TEST_SITE_KEY,
    REACT_APP_APM_SERVER_URL: process.env.REACT_APP_APM_SERVER_URL || APM_SERVER_URL_DEV,
    PORT: 3002,
  };

  const redirectToOnline = ["top"];

  const baseUrl: string = domainExtension === "hr" ? "https://zdravstveno.kompare." : "https://dzo-webshop.kompare.";
  const wsPayUrl: string = domainExtension === "hr" ? "https://form.wspay.biz/authorization.aspx" : "https://formtest.wspay.biz/authorization.aspx";
  const isDev: boolean = domainExtension !== "hr";

  return {
    REACT_APP_IS_DEV: isDev ? "true" : "false",
    REACT_APP_URL: `${baseUrl}${domainExtension}`,
    REACT_APP_KOMPARE_API_URL: `https://public-api-proxy.kompare.${redirectToOnline.includes(domainExtension) ? "online" : domainExtension}`,
    REACT_APP_API_URL: `https://health-api.kompare.${redirectToOnline.includes(domainExtension) ? "online" : domainExtension}`,
    REACT_APP_DMS_URL: `https://minio.kompare.hr`,
    REACT_APP_KOMPARE_HOME: `https://kompare.hr`,
    REACT_APP_WSPAY_URL: wsPayUrl,
    REACT_APP_ENVIRONMENT: domainExtension === "hr" ? "production" : domainExtension,
    REACT_APP_API_URL_ADDITIONAL: `https://health-api.kompare.${redirectToOnline.includes(domainExtension) ? "online" : domainExtension}`,
    REACT_APP_TARGET_ORIGIN: `https://crm-health.kompare.${redirectToOnline.includes(domainExtension) ? "online" : domainExtension}`,
    REACT_APP_TURNSTILE_SITE_KEY: TURNSTILE_SITE_KEYS[domainExtension] ?? TURNSTILE_TEST_SITE_KEY,
    REACT_APP_APM_SERVER_URL: domainExtension === "hr" ? APM_SERVER_URL_PRODUCTION : APM_SERVER_URL_DEV,
    PORT: 3003,
  };
};

const config: ConfigInterface = (() => getEnvVars())();

export default config;
